<template style="height: 100%;">
    <div class="Userpersonal CommonContentSingle-gray" v-loading="daochu">
        <el-form class="xforxm" v-if="identity" ref="form" :model="form" label-width="80px">
            <el-form-item label="姓名">
                <el-input placeholder="输入姓名查找" v-model="form.RealName"></el-input>
            </el-form-item>
            <el-form-item label="账号">
                <el-input v-model="form.UserID" :placeholder="'输入' + $t('original.account') + '查找'"></el-input>
            </el-form-item>
            <el-form-item label="角色类型">
                <el-select v-model="form.RoleID" placeholder="请选择角色类型">
                    <el-option v-for="item in value4" :key="item.DicKey" :label="item.CDicValue" :value="item.DicKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input v-model.trim="form.Phone" placeholder="输入手机号查找"></el-input>
            </el-form-item>
            <el-form-item class="cssoo" style="width: 300px; margin-left: 20px;">
                <el-button type="primary" @click="onSubmit">立即查找</el-button>
                <el-button @click="resetForm('form')">重置条件</el-button>
            </el-form-item>
        </el-form>
        <div class="Thelist">
            <div v-if="identity">
                <el-button type="primary" @click="handleClick">新增用户</el-button>
                <el-button type="primary" @click="uesrexport">用户导出</el-button>
            </div>
            <div class="Thelist_left" v-if="identity">
                <h2>部门名称</h2>
                <el-tree :data="data" node-key="value" check-strictly :expand-on-click-node="false"
                    @node-click="check_tree" @node-expand="check_tree" ref="treeForm"></el-tree>
            </div>
            <div class="Thelist_right" :class="{ Thelist_rights: !identity }">
                <h2>用户信息</h2>
                <el-table ref="multipleTable" v-loading="load" element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark"
                    style="width: 100%;" @selection-change="handleSelectionChange" @sort-change="sorting">
                    <el-table-column label="序号" width="50px">
                        <template slot-scope="scope">{{ (pssndex - 1) * 5 + scope.$index + 1 }}</template>
                    </el-table-column>
                    <el-table-column prop="UserID" label="账号" min-width="60px" sortable>
                    </el-table-column>
                    <el-table-column prop="RoleID" label="人员类型" min-width="60px"></el-table-column>
                    <el-table-column prop="RealName" label="姓名" min-width="60px"></el-table-column>
                    <el-table-column prop="Sex" label="性别" min-width="40px"></el-table-column>

                    <el-table-column prop="Birthday" label="出生日期" show-overflow-tooltip min-width="60">
                    </el-table-column>

                    <el-table-column prop="Phone" label="手机号" show-overflow-tooltip></el-table-column>
                    <el-table-column sortable prop="CreatedDate" label="创建日期" show-overflow-tooltip min-width="100">
                    </el-table-column>
                    <el-table-column width="80px" prop="LineNumber" label="排序" sortable="custom" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column width="80px" label="账号状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.FreezeType == '0'">正常</span>
                            <span v-else>已冻结</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="120px">
                        <template slot-scope="scope">
                            <span class="caozuo" @click="handleEdit(scope.$index, scope.row)">
                                详情
                            </span>
                            <span class="caozuo" @click="handleDelete(scope.$index, scope.row)" v-if="identity">
                                删除
                            </span>
                            <span class="caozuo" v-if="scope.row.Reset == 1" @click="chongzhi(scope.row)">
                                重置密码
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination style="margin-top: 20px; text-align: right;" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage1" :page-size="5" layout="total, prev, pager, next"
                    :total="totalnumber" :hide-on-single-page="wpppd"></el-pagination>
            </div>
        </div>

        <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false">
            <div class="basic">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item style="width: 100%;">
                        <div class="tit" style="margin-left: -80px;">
                            <span></span>
                            <p>基本信息</p>
                        </div>
                    </el-form-item>

                    <el-form-item label="人员类型" prop="RoleID">
                        <el-select v-model="ruleForm.RoleID" placeholder="请选择" multiple :disabled="bans">
                            <el-option-group v-for="group in optsssss" :key="group.key" :label="group.value">
                                <el-option v-for="item in group.RoleList" :key="item.key" :label="item.value"
                                    :value="item.key"></el-option>
                            </el-option-group>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="部门" prop="DeptID">
                        <div class="block">
                            <el-cascader :data="data" :placeholder="pdid ? ruleForm.PDeptName : '请选择'" :disabled="bans"
                                ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen"
                                v-model="ruleForm.DeptID" :options="options" :props="{ checkStrictly: true }" clearable>
                            </el-cascader>
                        </div>
                    </el-form-item>

                    <el-form-item disabled="true" :label="$t('original.account')" prop="UserID">
                        <el-input readonly="readonly" v-model="ruleForm.UserID"></el-input>
                    </el-form-item>

                    <el-form-item label="姓名" prop="RealName">
                        <el-input v-model="ruleForm.RealName"></el-input>
                    </el-form-item>

                    <el-form-item label="年级" prop="EntryDate">
                        <el-select v-model="ruleForm.EntryDate" placeholder="请选择年级">
                            <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="性别" prop="Sex">
                        <el-radio v-model="ruleForm.Sex" label="1">男</el-radio>
                        <el-radio v-model="ruleForm.Sex" label="0">女</el-radio>
                    </el-form-item>

                    <el-form-item label="出生日期" prop="Birthday">
                        <el-date-picker type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
                            value-format="yyyy-MM-dd" v-model="ruleForm.Birthday" :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item label="手机号" prop="Phone">
                        <el-input onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))" type="number"
                            v-model.trim="ruleForm.Phone"></el-input>
                    </el-form-item>

                    <el-form-item label="身份证号" prop="IDCard">
                        <el-input v-model="ruleForm.IDCard"></el-input>
                    </el-form-item>

                    <el-form-item label="户口类型" prop="AccountType">
                        <el-radio v-model="ruleForm.AccountType" label="2">城市</el-radio>
                        <el-radio v-model="ruleForm.AccountType" label="1">农村</el-radio>
                    </el-form-item>

                    <el-form-item label="监护人" prop="TheGuardian">
                        <el-input v-model="ruleForm.TheGuardian"></el-input>
                    </el-form-item>

                    <el-form-item label="监护人电话" prop="TheGuardianPhone">
                        <el-input v-model="ruleForm.TheGuardianPhone"></el-input>
                    </el-form-item>

                    <el-form-item label="籍贯" prop="NativePlace">
                        <el-select v-model="ruleForm.NativePlace" placeholder="请选择籍贯">
                            <el-option v-for="item in value24" :key="item.DicKey" :label="item.CDicValue"
                                :value="item.DicKey"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="民族" prop="Nation">
                        <el-select v-model="ruleForm.Nation" placeholder="请选择民族">
                            <el-option v-for="item in value22" :key="item.DicKey" :label="item.CDicValue"
                                :value="item.DicKey"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="备注" prop="SchoolRemark">
                        <el-input v-model="ruleForm.SchoolRemark"></el-input>
                    </el-form-item>

                    <el-form-item label="序号" prop="LineNumber">
                        <el-input v-model="ruleForm.LineNumber"></el-input>
                    </el-form-item>
                    <TemplateChild ref="MyChild" @func="getMsgFormSon"></TemplateChild>
                </el-form>
                <el-button v-if="!btn_switch" class="btn" @click="tobans" type="primary">修改</el-button>
                <el-button v-else class="btn" :disabled="csbjb" @click="btn_submit" type="primary">
                    提交
                </el-button>
            </div>
        </el-drawer>

        <el-dialog title="冻结原因" :visible.sync="wppdialogVisible" width="30%" :before-close="handleClose">
            <el-input v-model="liyou" maxlength="250" type="textarea" resize="none"></el-input>
            <el-button style="margin-top: 20px;" @click="quedingdongjie">确定</el-button>
        </el-dialog>
    </div>
</template>
<script>
import TemplateChild from '../templates'
export default {
    data() {
        return {
            value22: [],
            value4: [],
            value24: [],
            pdid: true,
            wpppd: true,
            wppdialogVisible: false,
            liyou: '',
            leixing: '',
            renid: '',
            data1: [],
            pssndex: 1,
            pickerOptions: { disabledDate(time) { return time.getTime() > Date.now() - 3600 * 1000 * 24 + 8.64e7 } },
            csbjb: false,
            daochu: false,
            sortingss: '',
            Student_id: '',
            create_time: '',
            totalnumber: 0,
            isAble: false,
            identity: false,
            currentPage1: 1,
            seledeptid: '',
            load: false,
            drawer: false,
            visible: false,
            bans: true,
            btn_switch: true,
            value: '',
            options: [],
            data: [],
            form: {
                RealName: '',
                UserID: '',
                RoleID: '',
                CreatedDate: '',
                Phone: '',
                pageSize: '5',
                pageIndex: '1',
                EntryDate: '',
            },
            ruleForm: {
                IndividualResume: '',
                VideoAccount: '',
                LineNumber: '',
                RealName: '',
                RoleID: ['1059', '1066'],
                UserID: '',
                DeptID: '',
                Sex: '1',
                Birthday: '',
                Phone: '',
                IDCard: '',
                AccountType: '2',
                CaseContent: '',
                ClinicDate: '',
                ClinicType: '',
                CaseRemark: '',
                Class: '',
                TheEntranceDate: '',
                TheGuardian: '',
                SchoolRemark: '',
                TheGuardianPhone: '',
                Nation: '',
                NativePlace: '',
                EntryDate: '',
                PDeptName: '',
            },
            optsssss: '',
            rules: {
                RealName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                RoleID: [{ required: true, message: '请选择人员类型', trigger: 'blur' },],
                EntryDate: [{ required: true, message: '请选择年级', trigger: 'blur' },],
                DeptID: [{ required: true, message: '请选择部门', trigger: 'blur' }],
                UserID: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                Sex: [{ required: true, message: '请选择性别', trigger: 'blur' }],
                Birthday: [{ type: 'date', required: true, message: '请选择出生日期', trigger: 'blur' }],
                AccountType: [{ required: true, message: '请选择户口类型', trigger: 'blur' }],
            },
            tableData: [],
            multipleSelection: [],
            YearList: [],
        }
    },
    components: {
        TemplateChild: TemplateChild,
    },
    methods: {
        Selected_to_shut_dow(dt) {
            // this.pdid = false
            this.ruleForm.DeptID = dt[dt.length - 1]
            this.$refs.wcascader.dropDownVisible = false
        },
        quedingdongjie() {
            this.$Http_Post('User/ThawFrozen', { UserID: this.renid, FreezeType: this.leixing, FreezeThe: this.liyou }).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                    this.Global.request_successful(res.Message)
                    this.wppdialogVisible = false
                    this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time)
                } else {
                    this.Global.request_failure(res.Message)
                }
            })
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done()
                })
                .catch((_) => { })
        },
        dongjie(val, id) {
            this.wppdialogVisible = true;
            this.renid = val.UserID;
            this.leixing = id;
        },
        chongzhi(val) {
            this.$Http_Post('User/ResetPassword', { UserID: val.UserID }).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                    this.Global.request_successful(res.Message);
                } else {
                    this.Global.request_failure(res.Message);
                }
            },)
        },
        getMsgFormSon(data) {
            this.msgFormSon = data;
        },
        sorting({ column, prop, order }) {
            if (prop == 'UserID') {
                this.Student_id = order;
                this.create_time = '';
                this.sortingss = '';
            } else if (prop == 'CreatedDate') {
                this.create_time = order;
                this.Student_id = '';
                this.sortingss = '';
            } else if (prop == 'LineNumber') {
                this.sortingss = order;
                this.Student_id = '';
                this.create_time = '';
            }
            this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time);
        },
        onSubmit() {
            this.seledeptid = '';
            this.form.pageIndex = 1;
            this.currentPage1 = 1;
            this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time);
        },
        check_tree(dt, obj, node) {
            if (dt.fuzi && dt.children.length > 0 && dt.children[0].DeptID == '-1') {
                dt.children = [{ label: '数据加载中...' }]
                this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt.DeptID, content: '' }).then((res) => {
                    if (res.Code == 200 || res.Code == 0) {
                        if (res.Data) {
                            dt.children = res.Data;
                        }
                    }
                })
            }
            this.arr = [dt.value];
            this.types = '2';
            this.seledeptid = dt.value;
            this.form.pageIndex = '1';
            this.currentPage1 = 1;
            this.loading(this.form, dt.value, this.sortingss, this.Student_id, this.create_time);
        },

        GetNodeByDeptID(ID, NodeList) {
            let obj = null;
            for (let i = 0; i < NodeList.length; i++) {
                if (NodeList[i].DeptID == ID) {
                    obj = NodeList[i];
                    break
                } else if (NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1') {
                    this.GetNodeByDeptID(ID, NodeList[i].children);
                }
            }
            return obj
        },

        bumen(dt) {
            let obj = this.options[0]
            for (let i = 0; i < this.options.length; i++) {
                if (this.options[i].DeptID == dt[dt.length - 1]) {
                    obj = this.options[i]
                    break
                } else if (this.options[i].fuzi && this.options[i].children.length > 0 && this.options[i].children[0].DeptID != '-1') {
                    obj = this.GetNodeByDeptID(
                        dt[dt.length - 1],
                        this.options[i].children,
                    )
                }
            }

            let _this = this
            if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
                obj.children = [{ label: '数据加载中...' }];
                this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
                    if (res.Code == 200 || res.Code == 0 && res.Data) {
                        obj.children = res.Data
                    }
                })
            }
        },
        handleCurrentChange(val) {
            this.form.pageIndex = val;
            this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time);
        },
        handleSizeChange(val) { },
        resetForm(formName) {
            this.form.RealName = '',
                this.form.UserID = '',
                this.form.RoleID = '',
                this.form.CreatedDate = '',
                this.form.Phone = '',
                this.form.RealName = '',
                this.form.RealName = '',
                this.form.pageIndex = 1,
                this.loading(this.form, '', this.sortingss, this.Student_id, this.create_time),
                this.currentPage1 = 1
        },
        uesrexport() {
            this.daochu = true
            this.$Http_Post('User/ExportUserData', { from: this.form, Language: 'Chinese', }).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                    this.daochu = false;
                    this.Global.request_successful(res.Message);
                    window.location.href = res.Data;
                } else {
                    this.daochu = false;
                    this.Global.request_failure(res.Message);
                }
            })
        },
        btn_submit() {

            if (this.ruleForm.Phone != undefined && this.ruleForm.Phone != null && this.ruleForm.Phone != '' && !this.Global.regMobile.test(this.ruleForm.Phone)) {
                this.Global.request_failure('手机号码格式错误');
            } else {

                if (this.msgFormSon) {
                    if (this.msgFormSon.dropListInfo.length > 0) {
                        var csi = this.msgFormSon.dropListInfo;
                        var lkokjcid = this.ruleForm;
                        for (var i = 0; i < csi.length; i++) {
                            lkokjcid[csi[i].Control] = csi[i].ControlValue;
                        }
                        this.ruleForm = lkokjcid;
                    }
                    if (this.msgFormSon.textBoxInfo.length > 0) {
                        var cs2i = this.msgFormSon.textBoxInfo;
                        var lkokjecid = this.ruleForm;
                        for (var i = 0; i < cs2i.length; i++) {
                            lkokjecid[cs2i[i].Control] = cs2i[i].ControlValue;
                        }
                        this.ruleForm = lkokjecid;
                    }
                }

                this.csbjb = true;
                this.$Http_Post('ReportCriData/UpdateUser', this.ruleForm).then((res) => {
                    if (res.Code == 200 || res.Code == 0) {
                        this.nav_list = res.Data;
                        this.Global.request_successful(res.Message);
                        this.drawer = false;
                        this.csbjb = false;
                        this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time);
                    } else {
                        this.Global.request_failure(res.Message)
                        this.csbjb = false
                    }
                })
            }
        },
        tobans() {
            this.bans = false;
        },
        handleClick() {
            this.$router.push({ path: '/ReportData/RPUserAdd' });
        },
        handleSelectionChange(val) {
            var cjdjcd = [];
            for (var i = 0; i < val.length; i++) {
                cjdjcd.push(val[i].UserID);
            }
            this.multipleSelection = cjdjcd;
        },
        handleEdit(index, row) {
            this.$nextTick(() => {
                this.$refs['ruleForm'].resetFields();
            });
            if (sessionStorage.getItem('entity') == '管理员') {
                this.bans = false;
            } else {
                this.bans = true;
            }
            this.$Http_Post('User/GetUserType').then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                    this.optsssss = res.Data
                }
            })

            this.$Http_Post('User/GetUpdateUser', { UserID: row.UserID }).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                    this.load = false,
                        this.drawer = true,
                        this.ruleForm.IndividualResume = res.Data.IndividualResume,
                        this.ruleForm.VideoAccount = res.Data.VideoAccount,
                        this.ruleForm.RoleID = res.Data.RoleIDs,
                        this.ruleForm.UserID = res.Data.UserID,
                        this.ruleForm.EntryDate = res.Data.EntryDate,
                        this.ruleForm.RealName = res.Data.RealName,
                        this.ruleForm.Sex = res.Data.Sex,
                        this.ruleForm.Birthday = res.Data.Birthday,
                        this.ruleForm.AccountType = res.Data.AccountType,
                        this.ruleForm.ClinicType = res.Data.ClinicType,
                        this.ruleForm.ClinicDate = res.Data.ClinicDate,
                        this.ruleForm.CaseContent = res.Data.CaseContent,
                        this.ruleForm.Phone = res.Data.Phone,
                        this.ruleForm.IDCard = res.Data.IDCard,
                        this.ruleForm.CaseRemark = res.Data.CaseRemark,
                        this.ruleForm.DeptID = res.Data.DeptID,
                        this.ruleForm.TheEntranceDate = res.Data.TheEntranceDate,
                        this.ruleForm.TheGuardian = res.Data.TheGuardian,
                        this.ruleForm.SchoolRemark = res.Data.SchoolRemark,
                        this.ruleForm.TheGuardianPhone = res.Data.TheGuardianPhone,
                        this.ruleForm.Nation = res.Data.Nation,
                        this.ruleForm.NativePlace = res.Data.NativePlace,
                        this.ruleForm.LineNumber = res.Data.LineNumber,
                        this.ruleForm.PDeptName = res.Data.DeptName,
                        this.$nextTick(() => { this.$refs.MyChild.RefushData(res.Data) })
                } else {
                    this.$notify.error({ title: '错误', message: res.Message })
                }
            },)
        },
        handleDelete(index, row) {//删除
            this.$confirm('此操作将永久删除该人员, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', showClose: false, closeOnClickModal: false, })
                .then(() => {
                    this.$Http_Post('User/DeleteUser', { UserID: row.UserID }).then((res) => {
                        this.$notify.closeAll();
                        if (res.Code == 200 || res.Code == 0) {
                            this.$notify({ title: '成功', message: res.Message, type: 'success', })
                            this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time,)
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.Message,
                            })
                        }
                    },
                    )
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除',
                    })
                })
        },
        loading(from, seledeptid, sortingss, id_ascending, data_ascending) {
            this.pssndex = from.pageIndex;
            this.load = true;
            this.$Http_Post('User/GetUserList', { from, seledeptid: seledeptid, sort: sortingss, idsort: id_ascending, datasort: data_ascending })
                .then((res) => {
                    if (res.Code == 200 || res.Code == 0) {
                        this.load = false;
                        if (res.Data.Counts >= 5) { this.wpppd = false } else { this.wpppd = true }
                        if (res.Data.Lists.length > 0) {
                            this.tableData = res.Data.Lists;
                            this.totalnumber = Number(res.Counts);
                            this.isAble = true;
                            setTimeout(function () {
                                this.isAble = false;
                            }, 2000)
                        } else {
                            this.load = false
                            if (Number(from.pageIndex) > 1) {
                                from.pageIndex = from.pageIndex - 1;
                                this.currentPage1 = this.currentPage1 - 1;
                                this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time);
                            } else {
                                this.tableData = res.Data.Lists;
                                this.totalnumber = Number(res.Counts);
                            }
                        }
                    } else {
                        this.$notify.closeAll();
                        this.$notify.error({ title: '错误', message: res.data.Message });
                    }
                })
        },
    },
    created() {
        this.loading(this.form, '', this.sortingss, this.Student_id, this.create_time);
    },
    mounted() {
        this.$Http_Post('User/GetDictionaryList', { DicTypCode: 1 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.gradedata = res.Data
      }
    })
        var date = new Date()
        let nowYear = new Date().getFullYear()
        for (let i = 0; i < 10; i++) {
            this.YearList.push(nowYear - i)
        }
        this.identity = this.Global.identity;
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '' }).then((res) => {
            this.options = res.Data;
            if (res.Data) { this.data = res.Data; }
        })

        this.$Http_Post('User/DictionaryList',{ DicTypCode :"4"}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
                this.value4 = res.Data
            }
        })

        this.$Http_Post('User/DictionaryList', { DicTypCode: "24" }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
                this.value24 = res.Data
            }
        })

        this.$Http_Post('User/DictionaryList', { DicTypCode: "22" }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
                this.value22 = res.Data
            }
        })
    },
}
</script>
<style>
.Userpersonal {
    height: calc(100% - 20px) !important;
    padding: 10px;
}

.Userpersonal .xforxm {
    font-size: 20px;
    border: 1px solid #e3e3e3;
    margin-top: -1px;
    background-color: #fff;
    margin-left: 0px;
    padding: 10px;
}

.Userpersonal .xforxm .el-form-item {
    margin-bottom: 10px;
    float: left;
    width: 33%;
}

.Userpersonal .el-form .el-form-item .el-form-item__label {
    width: 100px !important;
}

.Userpersonal .el-input__inner {
    height: 36px;
}

.Userpersonal .el-form .el-form-item .el-input {
    width: 80% !important;
}

.Userpersonal .el-form .el-form-item .el-date-editor {
    width: 80%;
}

.Userpersonal .el-form .el-form-item .el-select {
    width: 80%;
}

.Userpersonal .basic .el-select {
    width: 100% !important;
}

.Userpersonal .el-form .el-form-item .el-select .el-input {
    width: 100%;
}

.Userpersonal .xforxm {
    height: 100px;
}

.caozuo {
    margin-left: 10px;
    color: #409eff;
    cursor: pointer;
}

.Userpersonal .basic>h2 {
    font-size: 16px;
}

.Userpersonal .basic {
    width: 100%;
    margin-left: -10px;
    height: 1400px;
}

.Userpersonal .basic .tit span {
    width: 3px;
    height: 20px;
    background-color: rgba(0, 136, 255, 1);
    display: inline-block;
    position: absolute;
    left: 0px;
    top: 0px;
}

.Userpersonal .basic .tit p {
    position: absolute;
    left: 10px;
    top: -9px;
}

.Userpersonal .basic .tit {
    position: relative;
    margin-top: 16px;
    height: 30px;
    margin-left: 20px;
}

.Userpersonal .basic .el-textarea textarea {
    height: 80px;
}

.Userpersonal .btn {
    margin-left: 42%;
    margin-bottom: 50px;
}

.el-drawer__open .el-drawer.rtl {
    -webkit-animation: rtl-drawer-in 0.3s 1ms;
    animation: rtl-drawer-in 0.3s 1ms;
    width: 40% !important;
}

.Userpersonal .basic .el-form {
    margin-left: 20px;
    width: 80%;
}

.Userpersonal .basic .el-cascader {
    display: inline-block;
    position: relative;
    font-size: 14px;
    line-height: 40px;
    width: 100%;
}

.Userpersonal .Thelist_left {
    margin-top: 10px;
    width: 300px;
    border: 1px solid rgba(225, 226, 227, 1);
    float: left;
    height: calc(100% - 45px);
}

.Userpersonal .Thelist_left h2 {
    padding: 18px;
    font-size: 18px;
}

.Userpersonal .Thelist_right {
    width: calc(100% - 310px);
    border: 1px solid rgba(225, 226, 227, 1);
    float: right;
    height: calc(100% - 45px);
    overflow: auto;
    margin-top: 10px;
}

.Userpersonal .Thelist_rights {
    width: calc(100% - 2px);
}

.Userpersonal .Thelist_right h2 {
    padding-top: 18px;
    padding-left: 10px;
    font-size: 18px;
}

.Userpersonal .Thelist {
    width: calc(100% - 20px);
    margin-top: 8px;
    background-color: white;
    padding: 10px;
    height: calc(100% - 150px);
}

.Userpersonal .cssoo .el-form-item__content {
    margin-left: 0px !important;
}

.Userpersonal .el-textarea .el-input__count {
    height: 20px;
    bottom: 12px;
}

.Userpersonal .el-table .cell {
    text-align: center;
}

.Userpersonal .el-tree {
    min-width: 280px;
}

.nianji .el-form .el-form-item .el-input {
    width: 100% !important;
}
</style>
  